import { UseAPI } from './api';
import { Controllers } from '../constants/Controllers'

export async function RedefinirSenhaWebAPI ( Id, NewStr )
{
    try
    {
        let request = JSON.stringify( { Id, NewStr } )

        const response = await UseAPI( Controllers.ControllerAdmin + `RedefinirSenhaWeb`, request )

        return response

    } catch ( err )
    {

    }
}

export async function GetInactiveJobersAPI ()
{
    try
    {
        const response = await UseAPI( Controllers.ControllerAdmin + `GetInactiveJobers`, null, 2 )

        return response

    } catch ( err )
    {

    }
}

export async function InactiveJoberDocumentsAPI ( IdCliente )
{
    try
    {
        let request = JSON.stringify( { IdCliente } )

        const response = await UseAPI( Controllers.ControllerAdmin + `InactiveJoberDocuments`, request )

        return response

    } catch ( err )
    {

    }
}

export async function AtualizarInfoInactiveJoberDocumentAPI ( Selecionados, IdCliente )
{
    try
    {
        let request = JSON.stringify( { Selecionados, IdCliente } )

        const response = await UseAPI( Controllers.ControllerAdmin + `AtualizarInfoInactiveJoberDocument`, request )

        return response

    } catch ( err )
    {

    }
}

export async function LoginAdmAPI ( Login, Senha )
{
    try
    {
        let request = JSON.stringify( { Login, Senha } )

        const response = await UseAPI( Controllers.ControllerAdmin + `LoginAdm`, request )

        return response

    } catch ( err )
    {

    }
}

// export async function LoginAdmAPI ( Login, Senha )
// {
//     try
//     {
//         let request = JSON.stringify( { Login, Senha } )

//         const response = await UseAPI( `LoginAdm`, request )

//         debugger;

//         return response

//     } catch ( err )
//     {

//     }
// }
